import { likesReceivedConfig } from '../likesReceived';
import { SIZE_50 } from '@/lib/gridElements/size';
import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';

export const mediaViewerLikesConfig = {
    ...likesReceivedConfig,
    name: 'kpi.twitter.mediaviewer.likes',
    size: SIZE_50,
    loader: MediaViewerKpiLoader
};
